import React, { useEffect, useState } from 'react';
import { tenantAdminApi } from '../../utils/tenantAdminApi';
import { Building2 } from 'lucide-react';

function Row({ label, value, mono = false }) {
  return (
    <div className="flex items-baseline justify-between border-b last:border-0 py-3">
      <span className="text-sm text-zinc-500">{label}</span>
      <span className={`text-sm text-zinc-900 ${mono ? 'font-mono' : ''}`}>{value || '—'}</span>
    </div>
  );
}

export default function SettingsPage() {
  const [tenant, setTenant] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try { setTenant(await tenantAdminApi.tenant()); } catch (_) {}
      setLoading(false);
    })();
  }, []);

  if (loading) return <div className="p-8 text-sm text-zinc-500">Loading…</div>;
  if (!tenant) return <div className="p-8 text-sm text-red-600">Could not load tenant info.</div>;

  return (
    <div className="p-8 max-w-3xl">
      <h1
        className="text-2xl font-bold text-zinc-900"
        style={{ fontFamily: 'Manrope' }}
        data-testid="ta-settings-title"
      >
        Clinic info
      </h1>
      <p className="text-sm text-zinc-500 mt-1">
        Workspace-level configuration. To change the name, isolation mode, or status, contact your platform owner.
      </p>

      <div className="mt-6 bg-white border rounded-xl p-5">
        <div className="flex items-center gap-3 pb-4 border-b">
          <div className="h-11 w-11 rounded-lg bg-blue-50 text-blue-700 border border-blue-200 flex items-center justify-center">
            <Building2 className="h-5 w-5" />
          </div>
          <div>
            <div className="text-lg font-semibold text-zinc-900">{tenant.name}</div>
            <div className="text-xs text-zinc-500 font-mono">slug: {tenant.slug}</div>
          </div>
        </div>
        <Row label="Status" value={tenant.status} />
        <Row label="Plan" value={tenant.plan?.name || tenant.plan_code} />
        <Row label="Subscription status" value={tenant.subscription_status} />
        <Row label="Data isolation" value={tenant.isolation_mode === 'dedicated' ? 'Dedicated database (per-tenant DB)' : 'Shared database (multi-tenant)'} />
        <Row label="Created" value={tenant.created_at ? new Date(tenant.created_at).toLocaleString('en-IN', { dateStyle: 'medium', timeStyle: 'short', timeZone: 'Asia/Kolkata' }) : '—'} />
        <Row label="Custom domains" value={(tenant.allowed_domains || []).join(', ')} mono />
      </div>
    </div>
  );
}
